export const container = () => ({
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridColumnGap: '1rem',
    alignItems: 'center',
    marginBottom: '1.5rem',
    justifyContent: 'space-between',
});
